<script setup>
import { useGlobalStore } from "@/stores";
import { computed } from "vue";
import moment from "moment";

const globalStore = useGlobalStore();

const notifications = computed(() => {
  return globalStore.notifications;
});

const formatDateTime = (date) => {
  if (date === null) {
    return date;
  }
  return moment(date, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm");
};
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="page-title">Notifications</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex flex-column gap-10">
        <div
          v-for="notification in notifications"
          :key="notification.id"
          class="notification-box w-50 rounded"
        >
          <h2>{{ notification.title }}</h2>
          <p class="text-caption pb-2">
            {{ formatDateTime(notification.createdAt) }}
          </p>
          <v-divider class="pb-2" />
          <div class="pa-5" v-html="notification.text" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
h1 {
  color: rgb(var(--v-theme-primary));
}
.notification-box {
  background: white;
  padding: 10px;
  border: 1px solid #ddd;
}
.flex-50 {
  flex: 0 0 60% !important;
}
.flex-25 {
  flex: 0 0 20% !important;
}
</style>
